import { Loader2 } from 'lucide-react';
import { getProviderConfig } from '../../config/oauth-providers';
import type { OAuthProvidersSchema } from '@insforge/shared-schemas';
import type { CSSProperties } from 'react';
import { OAuthButton, OAuthButtonIcon, SubmitButtonSpinner } from './styled';

export interface AuthOAuthButtonProps {
  provider: OAuthProvidersSchema;
  onClick: (provider: OAuthProvidersSchema) => void;
  disabled?: boolean;
  loading?: boolean;
  displayMode?: 'full' | 'short' | 'icon';
  style?: CSSProperties;
}

/**
 * OAuth provider button with adaptive display modes.
 */
export function AuthOAuthButton({
  provider,
  onClick,
  disabled,
  loading,
  displayMode = 'full',
  style,
}: AuthOAuthButtonProps) {
  const config = getProviderConfig(provider);

  if (!config) {
    return null;
  }

  const getButtonText = () => {
    if (displayMode === 'full') {
      return `Continue with ${config.name}`;
    }
    if (displayMode === 'short') {
      return config.name;
    }
    return '';
  };

  const variant = displayMode === 'icon' ? 'iconOnly' : displayMode;

  return (
    <OAuthButton
      type="button"
      onClick={() => onClick(provider)}
      $variant={variant}
      disabled={disabled || loading}
      style={style}
    >
      {loading ? (
        <SubmitButtonSpinner>
          <Loader2 size={18} />
        </SubmitButtonSpinner>
      ) : (
        <OAuthButtonIcon>{config.svg}</OAuthButtonIcon>
      )}
      {!loading && getButtonText() && <span>{getButtonText()}</span>}
    </OAuthButton>
  );
}
